import React from 'react';
import { menuConfig } from '../config/menutopconfig';
import MenuBottom from './menubottom';

class MenuTop extends MenuBottom {
    render() {
        const { showLogin, logout } = this.props.appActions;
        const { isLoggedIn } = this.props.userState;

        return (
            <ul className="menu">
                {isLoggedIn ? (
                    <li className="menu-item">
                        <span onClick={logout}>logout</span>
                    </li>
                ) : (
                    <li className="menu-item menu-item-login">
                        <span onClick={showLogin}>login</span>
                    </li>
                )}
                {menuConfig.length ? menuConfig.map((item, i) => this.renderMenuItem(item, i)) : null}
            </ul>
        );
    }
}

export default MenuTop;



// WEBPACK FOOTER //
// ./source/components/menutop.js